import styled from "styled-components";

export const StyledHero = styled.section`
  position: relative;
  background-image: linear-gradient(
      rgba(34, 34, 34, 0.85),
      rgba(34, 34, 34, 0.85)
    ),
    url("/images/hero-bg.jpg");
  background-size: cover;
  background-position: center;
  color: var(--light-text);
  height: 100vh;
  display: flex;
  align-items: center;
  text-align: left;
  padding-top: 80px;
  overflow: hidden;

  &::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: linear-gradient(
      135deg,
      rgba(255, 107, 0, 0.3) 0%,
      rgba(34, 34, 34, 0) 50%
    );
    z-index: 1;
  }

  .container {
    width: 100%;
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 20px;
    position: relative;
    z-index: 2;
  }

  @media (max-height: 800px) and (min-width: 768px) {
    padding-top: 200px;
  }

  @media (max-width: 576px) {
    padding-top: 60px;
    height: 90vh;
  }

  @media (max-width: 576px) {
    padding-top: 60px;
    height: 90vh;
  }
`;

export const HeroContent = styled.div`
  max-width: 700px;
  position: relative;
  z-index: 2;

  h1 {
    font-size: 3.8rem;
    margin-bottom: 20px;
    animation: fadeInUp 1s ease;
    color: var(--light-text);
    position: relative;
    font-family: poppins, sans-serif;

    span {
      color: var(--primary-color);
    }

    &::after {
      content: "";
      position: absolute;
      bottom: -10px;
      left: 0;
      width: 230px;
      height: 3px;
      background-color: var(--primary-color);
    }

    @media (max-width: 992px) {
      font-size: 3rem;
    }

    @media (max-width: 768px) {
      font-size: 2.5rem;
    }

    @media (max-width: 576px) {
      font-size: 2rem;

      &::after {
        width: 80px;
        height: 2px;
      }
    }

    @media (max-width: 375px) {
      font-size: 1.8rem;
    }
  }

  p {
    font-size: 1.2rem;
    margin-bottom: 30px;
    font-family: Gunar thin, sans-serif;
    font-weight: bold;
    animation: fadeInUp 1s ease 0.2s;
    animation-fill-mode: both;
    color: var(--light-text);
    letter-spacing: 1.5px;

    @media (max-width: 768px) {
      font-size: 1.1rem;
    }

    @media (max-width: 576px) {
      font-size: 1rem;
      margin-bottom: 25px;
    }
  }

  .btn {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 12px 30px;
    border-radius: 8px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.3s ease;
    border: none;
    font-size: 1rem;
    animation: fadeInUp 1s ease 0.4s;
    animation-fill-mode: both;
    text-decoration: none;

    &.btn-primary {
      background-color: var(--primary-color);
      color: var(--light-text);
      position: relative;
      overflow: hidden;

      &:hover {
        background-color: var(--primary-dark);
        transform: translateY(-3px);
      }

      &::after {
        content: "";
        position: absolute;
        top: -50%;
        left: -50%;
        width: 200%;
        height: 200%;
        background: linear-gradient(
          45deg,
          rgba(255, 255, 255, 0) 0%,
          rgba(255, 255, 255, 0.1) 50%,
          rgba(255, 255, 255, 0) 100%
        );
        transform: rotate(45deg);
        animation: shine 3s infinite;
      }

      i {
        margin-right: 10px;
      }
    }

    @media (max-width: 576px) {
      padding: 10px 20px;
      font-size: 0.9rem;
    }
  }

  @keyframes fadeInUp {
    from {
      opacity: 0;
      transform: translateY(20px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  @keyframes shine {
    0% {
      left: -50%;
      top: -50%;
    }
    100% {
      left: 150%;
      top: 150%;
    }
  }
`;

export const HeroTechElements = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
  overflow: hidden;
`;

export const TechParticles = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
`;

export const TechCircle = styled.div`
  position: absolute;
  top: 10%;
  right: 10%;
  width: 250px;
  height: 250px;
  border: 2px solid #ff6a0093;
  box-shadow: 0 0 20px #ff6a0044;

  border-radius: 50%;
  animation: pulse 4s infinite alternate;

  &::before {
    content: "";
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 175px;
    height: 175px;
    border: 1px solid #ff6a0094;
    box-shadow: 0 0 20px #ff6a0044;
    border-radius: 50%;
  }

  &::after {
    content: "";
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 100px;
    height: 100px;
    border: 1px solid #ff6a009f;
    box-shadow: 0 0 20px #ff6a0044;
    border-radius: 50%;
  }

  @keyframes pulse {
    0% {
      transform: scale(1);
      opacity: 0.3;
    }
    100% {
      transform: scale(1.1);
      opacity: 0.1;
    }
  }

  @media (max-width: 768px) {
    width: 200px;
    height: 200px;
    right: 5%;

    &::before {
      width: 120px;
      height: 120px;
    }

    &::after {
      width: 60px;
      height: 60px;
    }
  }

  @media (max-width: 576px) {
    width: 150px;
    height: 150px;
    top: 15%;

    &::before {
      width: 100px;
      height: 100px;
    }

    &::after {
      width: 50px;
      height: 50px;
    }
  }

  @media (max-width: 375px) {
    width: 120px;
    height: 120px;

    &::before {
      width: 80px;
      height: 80px;
    }

    &::after {
      width: 40px;
      height: 40px;
    }
  }
`;

export const TechLine = styled.div`
  position: absolute;
  bottom: 20%;
  left: 0;
  width: 100%;
  height: 1px;
  background: linear-gradient(
    90deg,
    transparent,
    rgba(255, 107, 0, 0.5),
    transparent
  );
  animation: slide 3s infinite alternate;

  &::before {
    content: "";
    position: absolute;
    bottom: 10px;
    left: 0;
    width: 100%;
    height: 1px;
    background: linear-gradient(
      90deg,
      transparent,
      rgba(255, 107, 0, 0.3),
      transparent
    );
    animation: slide 3s infinite alternate-reverse;
  }

  &::after {
    content: "";
    position: absolute;
    bottom: -10px;
    left: 0;
    width: 100%;
    height: 1px;
    background: linear-gradient(
      90deg,
      transparent,
      rgba(255, 107, 0, 0.2),
      transparent
    );
    animation: slide 3s infinite alternate;
  }

  @keyframes slide {
    0% {
      transform: translateX(-30%);
    }
    100% {
      transform: translateX(30%);
    }
  }

  @media (max-width: 576px) {
    bottom: 15%;

    &::before {
      bottom: 8px;
    }

    &::after {
      bottom: -8px;
    }
  }
`;

export const TechDots = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-image: radial-gradient(
    rgba(255, 107, 0, 0.2) 1px,
    transparent 1px
  );
  background-size: 30px 30px;
  opacity: 0.3;

  @media (max-width: 576px) {
    background-size: 20px 20px;
  }
`;
